function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var aftersch = function aftersch(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "38",
    height: "38",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "29",
    width: "8",
    height: "3",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "21",
    width: "8",
    height: "3",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "25",
    y: "29",
    width: "8",
    height: "3",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "25",
    y: "21",
    width: "8",
    height: "3",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "27",
    y1: "25",
    x2: "27",
    y2: "29",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "7",
    y1: "25",
    x2: "7",
    y2: "29",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "5",
    y1: "30",
    x2: "5",
    y2: "38",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "25",
    y1: "30",
    x2: "25",
    y2: "38",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "31",
    y1: "25",
    x2: "31",
    y2: "29",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "11",
    y1: "25",
    x2: "11",
    y2: "29",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "13",
    y1: "30",
    x2: "13",
    y2: "38",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "33",
    y1: "30",
    x2: "33",
    y2: "38",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "1",
    width: "28",
    height: "15",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "34",
    y1: "13",
    x2: "6",
    y2: "13",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "13",
    y1: "23",
    x2: "17",
    y2: "23",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "33",
    y1: "23",
    x2: "37",
    y2: "23",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "1",
    y1: "23",
    x2: "5",
    y2: "23",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "21",
    y1: "23",
    x2: "25",
    y2: "23",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "17",
    y1: "22",
    x2: "17",
    y2: "38",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 22L37 38",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 22L1 38",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "21",
    y1: "22",
    x2: "21",
    y2: "38",
    stroke: "black",
    strokeWidth: "2"
  }));
};

export default aftersch;